module.exports = __webpack_public_path__ + "img/494c78598d48fb01150c35501c9027e4.png";